import { Node } from 'prosemirror-to-html-js';

export default class Image extends Node {
  matching() {
    return this.node.type === 'image';
  }

  tag() {
    const attrs = this.node.attrs || {};
    const position = attrs.position || 'left';
    const size = attrs.size || 'full';
    
    const classes = ['output-image'];
    if (position) {
      classes.push(`output-image--${position}`);
    }
    if (size) {
      classes.push(`output-image--${size}`);
    }

    return [
      {
        tag: 'img',
        attrs: {
          src: attrs.src || '',
          alt: attrs.alt || '',
          title: attrs.title || '',
          class: classes.join(' '),
          'data-position': position,
          'data-size': size,
        },
      },
    ];
  }
}
